import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNotePlanBody, PatientCareCenterNotePlanBodyDN, PatientCareCenterNotePlanBodyDC, PatientCareCenterNotePlanFoto, PatientCareCenterNotePlanOdg } from 'PatientCareCenter/Note/Plan'
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'


class PatientCareCenterNotePlan extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='plan' name='Plan' refProp={this.props.refProp} className={styles.required}>
                {this.props.noteType === 2 &&
                    <PatientCareCenterNotePlanBodyDN />
                }
                {(this.props.noteType === 1 || this.props.noteType === 3 || this.props.noteType === 5) &&
                    <PatientCareCenterNotePlanBody />
                }
              
                {(this.props.noteType === 4 || this.props.noteType === 6) &&
                    <PatientCareCenterNotePlanBodyDC />
                }
                <PatientCareCenterNoteSection id='plan_ref_guidelines' name='Reference Guidelines' leve={1}>
                    <PatientCareCenterNotePlanFoto />
                    <PatientCareCenterNotePlanOdg />
                </PatientCareCenterNoteSection>
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);

    return {
        noteType,
    };
}

const connectedPatientCareCenterNotePlan = connect(mapStateToProps)(PatientCareCenterNotePlan);
export { connectedPatientCareCenterNotePlan as PatientCareCenterNotePlan };




